// extracted by mini-css-extract-plugin
export default {"loyalityStore":"LoyalityStore_loyalityStore__ANkci","loyalityStore__wings":"LoyalityStore_loyalityStore__wings__HZxG0"};